var _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerbosityDetailed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14457 10.2476H20.2356C20.8808 10.2476 21.3595 9.74812 21.3595 9.10298C21.3595 8.47867 20.8808 8 20.2356 8H8.14457C7.47863 8 7 8.47867 7 9.10298C7 9.74812 7.47863 10.2476 8.14457 10.2476Z",
    fill: "#02080E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14457 15.9285H20.2356C20.8808 15.9285 21.3595 15.4082 21.3595 14.7631C21.3595 14.1596 20.8808 13.6602 20.2356 13.6602H8.14457C7.47863 13.6602 7 14.1596 7 14.7631C7 15.4082 7.47863 15.9285 8.14457 15.9285Z",
    fill: "#02080E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14457 21.7723H20.2356C20.8808 21.7723 21.3595 21.252 21.3595 20.6068C21.3595 20.0033 20.8808 19.5039 20.2356 19.5039H8.14457C7.47863 19.5039 7 20.0033 7 20.6068C7 21.252 7.47863 21.7723 8.14457 21.7723Z",
    fill: "#02080E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14457 27.6707H20.2356C20.8808 27.6707 21.3595 27.1504 21.3595 26.5053C21.3595 25.9018 20.8808 25.4023 20.2356 25.4023H8.14457C7.47863 25.4023 7 25.9018 7 26.5053C7 27.1504 7.47863 27.6707 8.14457 27.6707Z",
    fill: "#02080E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 25,
    height: 33,
    rx: 2.5,
    stroke: "#B1BAC3",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerbosityDetailed);
export default __webpack_public_path__ + "static/media/verbosity_detailed.107679fd70915c10e651c8e5fc772900.svg";
export { ForwardRef as ReactComponent };